/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiserviceMelcoModelsDesign,
    ApiserviceMelcoModelsDesignFromJSON,
    ApiserviceMelcoModelsDesignToJSON,
    ApiserviceMelcoModelsError,
    ApiserviceMelcoModelsErrorFromJSON,
    ApiserviceMelcoModelsErrorToJSON,
} from '../models';

export interface ColorizeApiUserDesignsDesignEditorColorizePreviewRequest {
    designFile?: Blob;
    colorFile?: Blob;
}

export interface ColorizeApiUserDesignsDesignEditorDownloadRequest {
    designFile?: Blob;
    colorFile?: Blob;
}

export interface ColorizeApiUserDesignsDesignEditorMetadataRequest {
    designFile?: Blob;
}

/**
 * 
 */
export class ColorizeApi extends runtime.BaseAPI {

    /**
     */
    async userDesignsDesignEditorColorizePreviewRaw(requestParameters: ColorizeApiUserDesignsDesignEditorColorizePreviewRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.designFile !== undefined) {
            formParams.append('design_file', requestParameters.designFile as any);
        }

        if (requestParameters.colorFile !== undefined) {
            formParams.append('color_file', requestParameters.colorFile as any);
        }

        const response = await this.request({
            path: `/design-editor/colorize/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorColorizePreview(requestParameters: ColorizeApiUserDesignsDesignEditorColorizePreviewRequest): Promise<Blob> {
        const response = await this.userDesignsDesignEditorColorizePreviewRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorDownloadRaw(requestParameters: ColorizeApiUserDesignsDesignEditorDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.designFile !== undefined) {
            formParams.append('design_file', requestParameters.designFile as any);
        }

        if (requestParameters.colorFile !== undefined) {
            formParams.append('color_file', requestParameters.colorFile as any);
        }

        const response = await this.request({
            path: `/design-editor/colorize/download`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorDownload(requestParameters: ColorizeApiUserDesignsDesignEditorDownloadRequest): Promise<Blob> {
        const response = await this.userDesignsDesignEditorDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorMetadataRaw(requestParameters: ColorizeApiUserDesignsDesignEditorMetadataRequest): Promise<runtime.ApiResponse<ApiserviceMelcoModelsDesign>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.designFile !== undefined) {
            formParams.append('design_file', requestParameters.designFile as any);
        }

        const response = await this.request({
            path: `/design-editor/colorize/metadata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDesignEditorMetadata(requestParameters: ColorizeApiUserDesignsDesignEditorMetadataRequest): Promise<ApiserviceMelcoModelsDesign> {
        const response = await this.userDesignsDesignEditorMetadataRaw(requestParameters);
        return await response.value();
    }

}
